<template>
  <f7-page
    :page-content="false"
  >
    <f7-navbar
      :sliding="false"
      innerClass="navbar-separator"
    >
          <!-- <f7-nav-left>
        <f7-link @click="atras()">
          <f7-icon class="text-madai" icon="icon-back"></f7-icon>
        </f7-link>
      </f7-nav-left> -->
      <f7-nav-title class="text-madai" title="Diseño Personalizado" subtitle="Cotización"></f7-nav-title>
    </f7-navbar>

    <f7-toolbar tabbar position="top">
      <f7-link :tab-link-active="tabSeleccionado === 0" @click="tabSeleccionado = 0">
        <img v-if="paso1" src="assets/img/otros/check.png" alt="" width="16" style="position: absolute; top: 10px; right: 30px;">
        <i class="material-icons">description</i>
      </f7-link>
      <f7-link :tab-link-active="tabSeleccionado === 1" @click="tabSeleccionado = 1">
        <img v-if="paso2" src="assets/img/otros/check.png" alt="" width="16" style="position: absolute; top: 10px; right: 30px;">
        <img src="assets/img/menu/compromiso.svg" alt="" width="28" class="m-l-0">
      </f7-link>
      <f7-link :tab-link-active="tabSeleccionado === 2" @click="tabSeleccionado = 2">
        <img v-if="paso3" src="assets/img/otros/check.png" alt="" width="16" style="position: absolute; top: 10px; right: 30px;">
        <i class="material-icons">assignment_turned_in</i>
      </f7-link>
      <f7-link :tab-link-active="tabSeleccionado === 3" @click="tabSeleccionado = 3">
        <img v-if="paso4" src="assets/img/otros/check.png" alt="" width="16" style="position: absolute; top: 10px; right: 30px;">
        <i class="material-icons">person</i>
      </f7-link>
    </f7-toolbar>
    <f7-tabs>
      <f7-tab class="page-content" :tab-active="tabSeleccionado === 0">
        <f7-block class="m-b-15 bold">¿Quieres algo para ti? ó ¿Para alguien especial?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta1" :smart-select-params="{ closeOnSelect: true }" class="required" title="Selecciona una opción" smart-select>
            <select name="para-quien-es" v-on:change="cuestionario.respuesta1 = $refs.respuesta1.f7SmartSelect.getValue()" v-bind:key="'f1'">
              <option value="X" selected>Seleccionar</option>
              <option value="Para mi">Para mi</option>
              <option value="Alguien más">Alguien más</option>
              <option value="Para mi y alguien más">Para mi y alguien más</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿Tienes un diseño en mente? o ¿Te gustaría que te propusieramos ideas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta2" :smart-select-params="{ closeOnSelect: true }" class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente" v-on:change="cuestionario.respuesta2 = $refs.respuesta2.f7SmartSelect.getValue()" v-bind:key="'f2'">
              <option value="X" selected>Seleccionar</option>
              <option value="Me gustaría recibir ideas">Me gustaría recibir ideas</option>
              <option value="No estoy seguro (a) de cómo será, pero tengo ideas">No estoy seguro (a) de cómo será, pero tengo ideas</option>
              <option value="Ya sé que diseño va a tener">Ya sé que diseño va a tener</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Háznos saber si tienes una fecha planeada para asegurarnos de tenerlo a tiempo</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta3" :smart-select-params="{ closeOnSelect: true }" class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente" v-on:change="cuestionario.respuesta3 = $refs.respuesta3.f7SmartSelect.getValue()" v-bind:key="'f3'">
              <option value="X" selected>Seleccionar</option>
              <option value="Solo necesito cotización">Solo necesito cotización</option>
              <option value="Será pronto (menos de 3 meses)">Será pronto (menos de 3 meses)</option>
              <option value="No tengo prisa (mas de 3 meses)">No tengo prisa (mas de 3 meses)</option>
              <option value="Sí, tengo fecha">Sí, tengo fecha</option>
            </select>
          </f7-list-item>
          <li class="required" v-if="cuestionario.respuesta3 === 'Sí, tengo fecha'">
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Selecciona la fecha de entrega</div>
                <div class="item-input-wrap">
                  <input
                    type="text"
                    readonly="readonly"
                    placeholder="Selecciona la fecha de entrega"
                    ref="respuesta4"
                    v-on:change="actualizarFecha"
                  />
                </div>
              </div>
            </div>
          </li>
        </f7-list>

        <f7-block class="m-b-15 bold required">¿Cuál es tu rango de precio?</f7-block>
        <f7-block class="m-0 m-b-100">
          <f7-list class="f7-list-item-no-border m-0">
            <f7-list-item>
              <f7-range
                @range:change="actualizarPresupuesto"
                ref="respuesta5"
                :min="25000"
                :max="100000"
                :step="2500"
                :value="cuestionario.respuesta5"
                :label="true"
                :dual="true"
              ></f7-range>
            </f7-list-item>
          </f7-list>

          <f7-row>
            <f7-col>
              <f7-list class="m-t-0" no-hairlines>
                <li>
                  <div class="item-content item-input">
                    <div class="item-inner">
                      <div class="item-title item-label">Mínimo</div>
                      <div class="item-input-wrap">
                        <input
                          type="text"
                          placeholder=""
                          :value="min"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </f7-list>
            </f7-col>
            <f7-col>
              <f7-list class="m-t-0" no-hairlines>
                <li>
                  <div class="item-content item-input">
                    <div class="item-inner">
                      <div class="item-title item-label">Máximo</div>
                      <div class="item-input-wrap">
                        <input
                          type="text"
                          placeholder=""
                          :value="max"
                        />
                      </div>
                    </div>
                  </div>
                </li>
              </f7-list>
            </f7-col>
          </f7-row>
        </f7-block>
      </f7-tab>
      <f7-tab class="page-content" :tab-active="tabSeleccionado === 1">
        <f7-block class="m-b-15 bold">¿De qué material lo deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta6" :smart-select-params="{ closeOnSelect: true }" class="required" title="Selecciona una opción" smart-select>
            <select v-on:change="cuestionario.respuesta6 = $refs.respuesta6.f7SmartSelect.getValue()" name="seleccion-material" v-bind:key="'f4'">
              <option value="X" data-option-image="" selected>Seleccionar</option>
              <option value="14k" data-option-image="assets/img/cuestionario_img/material_14k_75.png">14 kilates</option>
              <option value="18k" data-option-image="assets/img/cuestionario_img/material_18k_75.png">18 kilates</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿De qué color lo deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta7" :smart-select-params="{ closeOnSelect: true }" class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion-color" v-on:change="cuestionario.respuesta7 = $refs.respuesta7.f7SmartSelect.getValue()" v-bind:key="'f5'">
              <option value="X" data-option-image="" selected>Seleccionar</option>
              <option value="Oro Amarillo" data-option-image="assets/img/cuestionario_img/color_oro_amarillo_75.png" >Oro Amarillo</option>
              <option value="Oro Blanco" data-option-image="assets/img/cuestionario_img/color_oro_blanco_75.png">Oro Blanco</option>
              <option value="Oro Rosa" data-option-image="assets/img/cuestionario_img/color_oro_rosa_75.png">Oro Rosa</option>
              <!-- <option value="Oro Blanco y Rosa" data-option-image="assets/img/cuestionario_img/color_oro_blanco_rosa_75.png">Oro Blanco y Rosa</option>
              <option value="Oro Blanco y Amarillo" data-option-image="assets/img/cuestionario_img/color_oro_blanco_amarillo_75.png">Oro Blanco y Amarillo</option>
              <option value="Florentino" data-option-image="assets/img/cuestionario_img/color_florentino_75.png">Florentino</option> -->
            </select>
          </f7-list-item>
        </f7-list>
      </f7-tab>
      <f7-tab class="page-content" :tab-active="tabSeleccionado === 2">
        <f7-block class="m-b-15 bold">Descríbenos tu idea, no omitas ningún detalle</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            type="textarea"
            placeholder="Escribela aquí"
            :value="cuestionario.respuesta14"
            @input="cuestionario.respuesta14 = $event.target.value"
          >
          </f7-list-input>
        </f7-list>
        <div>
          <f7-block class="m-b-15 bold">Adjuntar imagenes</f7-block>
          <input @change="imagenesSeleccionadas($event)" ref="fileInput" type='file' name='filename' hidden/>
          <f7-list>
            <f7-list-item v-for="(imagen, idx) in cuestionario.imagenes" v-bind:key="idx" :title="'Imagen ' + Number(idx + 1)" @click="eliminarImagen(imagen)" after="eliminar">
              <img slot="media" :src="imagen" width="44" />
            </f7-list-item>
          </f7-list>
          <f7-block>
            <f7-progressbar v-if="cargandoImagen" infinite></f7-progressbar>
            <f7-list class="m-b-80" inset>
              <f7-list-item>
                <f7-button @click="buscarImagen()" class="margin-auto" fill :disabled="cargandoImagen">
                  Cargar Imagenes
                </f7-button>
              </f7-list-item>
            </f7-list>
          </f7-block>
        </div>
        <f7-block class="m-b-15 bold">¿Deseas agregar algún grabado?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item ref="respuesta8" title="Selecciona una opción" smart-select :smart-select-params="{openIn: 'popover'}">
            <select name="seleccion-medida" v-on:change="cuestionario.respuesta8 = $refs.respuesta8.f7SmartSelect.getValue()" v-bind:key="'f6'">
              <option value="X" selected>Seleccionar</option>
              <option value="Sin grabado">No</option>
              <option value="Con grabado">Si</option>
            </select>
          </f7-list-item>
          <f7-list-input
            v-if="false/*cuestionario.respuesta8 === 'Con grabado'*/"
            class="required"
            label="Escribe lo que se grabará"
            type="text"
            :value="cuestionario.respuesta9"
            @input="cuestionario.respuesta9 = $event.target.value"
            placeholder="Escribelo aquí"
          ></f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Información Adicional</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            label="Información adicional"
            type="textarea"
            placeholder="Escribela aquí"
            :value="cuestionario.respuesta10"
            @input="cuestionario.respuesta10 = $event.target.value"
          >
          </f7-list-input>
        </f7-list>
      </f7-tab>
      <f7-tab class="page-content" :tab-active="tabSeleccionado === 3">
        <f7-block class="m-b-15 bold">Información personal</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            class="required"
            label="Nombre Completo"
            type="text"
            placeholder="Nombre"
            :value="cuestionario.respuesta11"
            @input="cuestionario.respuesta11 = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Celular o Whatsapp a 10 dígitos"
            type="text"
            placeholder="Número"
            maxlength="10"
            :value="cuestionario.respuesta12"
            @input="cuestionario.respuesta12 = $event.target.value"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Correo Electrónico"
            type="text"
            placeholder="Correo"
            :value="cuestionario.respuesta13"
            @input="cuestionario.respuesta13 = $event.target.value"
          ></f7-list-input>
        </f7-list>

        <f7-block class="bold text-madai fs-14">
          La información personal se mantendrá estrictamente confidencial y no se venderá, reutilizará, alquilará,
          prestará ni divulgará de otro modo. Solo se utilizará como medio de contacto para hacerte llegar la cotización.
        </f7-block>

        <f7-list class="m-b-80" inset>
          <f7-list-item>
            <f7-button @click="enviarFormulario" class="margin-auto" fill :disabled="enviandoMensaje || (paso1 === false || paso2 === false || paso3 === false || paso4 === false)">Enviar</f7-button>
          </f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>

    <f7-toolbar tabbar position="bottom">
      <f7-link v-if="tabSeleccionado !== 0" @click="tabSeleccionado > 0 ? tabSeleccionado-- : tabSeleccionado">Anterior</f7-link>
      <f7-link v-if="tabSeleccionado < 3" @click="tabSeleccionado < tabs.length-1 ? tabSeleccionado++ : tabSeleccionado">Siguiente</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
/* eslint-disable */
import axios from 'axios'

export default {
  data () {
    return {
      tabs: [1, 2, 3, 4],
      tabSeleccionado: 0,
      calendario: '',
      presupuesto: '',
      min: 25000,
      max: 100000,
      max_string: '100000',
      cargandoImagen: false,
      enviandoMensaje: false,
      cuestionario: {
        respuesta1: 'X',
        respuesta2: 'X',
        respuesta3: 'X',
        respuesta4: '',
        respuesta5: [25000, 100000],
        respuesta6: 'X',
        respuesta7: 'X',
        respuesta8: 'X',
        respuesta9: '',
        respuesta10: '',
        respuesta11: '',
        respuesta12: '',
        respuesta13: '',
        respuesta14: '',
        imagenes: []
      },
      paso1: false,
      paso2: false,
      paso3: false,
      paso4: false
    }
  },
  watch: {
    'cuestionario.respuesta3' (val) {
      if (val === 'Sí, tengo fecha') {
        this.$f7.utils.nextFrame(() => {
          this.calendario = this.$f7.calendar.create({
            inputEl: this.$refs.respuesta4,
            dateFormat: 'yyyy/mm/dd',
            value: [new Date()]
          })
        })
      }
    },
    tabSeleccionado (val) {
      if (val === 0) {
        this.$f7.utils.nextFrame(() => {
          this.$refs.respuesta5.setValue(this.cuestionario.respuesta5)
        })
      }
      // if (val === 1 || val === 2 || val === 3) {
      //   this.paso1 = true
      // }
      // if (val === 2 || val === 3) {
      //   this.paso2 = true
      // }
    },
    cuestionario: {
      deep: true,
      handler (val) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        
        if(val.respuesta1 != "X" && val.respuesta2 != "X" && val.respuesta3 != "X"){
          this.paso1 = true
        }
        else{
          this.paso1 = false
        }
        if(val.respuesta6 != "X" && val.respuesta7 != "X"){
          this.paso2 = true
        }
        else{
          this.paso2 = false
        }
        if (val.respuesta8 === 'Con grabado') {
          if (val.respuesta9 !== '' !== '' && val.respuesta14 !== '') {
            this.paso3 = true
          } else {
            this.paso3 = false
          }
        } else {
          if (val.respuesta8 !== "X" && val.respuesta14 !== '') {
            this.paso3 = true
          } else {
            this.paso3 = false
          }
        }

        if (val.respuesta11 !== '' && val.respuesta12.length == 10 && val.respuesta13 !== '' && emailPattern.test(val.respuesta13)) {
          this.paso4 = true
        } else {
          this.paso4 = false
        }
      }
    }
  },
  methods: {
    atras () {
      let path = this.$f7.views.main.router.currentRoute.path
      if (path.includes('personalizado/otro')) {
        this.$f7.views.main.router.navigate('/personalizado/')
      }
    },
    actualizarFecha () {
      this.$f7.utils.nextFrame(() => {
        this.$set(this.cuestionario, 'respuesta4', this.calendario.getValue()[0])
      })
    },
    actualizarPresupuesto (values) {
      if (this.tabSeleccionado === 0) {
        this.min = values[0]
        this.max = values[1]
        this.$set(this.cuestionario, 'respuesta5', values)
      }
    },
    //cotizacion@madai.mx
    async enviarFormulario () {
      this.cuestionario.imagenes = this.cuestionario.imagenes.map(imagen => `<img src="${imagen}" alt=""><br><br>`)
      let correo = {
        para: 'contactomadai@gmail.com',
        asunto: 'Formulario Personalizados Página Web',
        mensaje: `
          <div style="border: 1px solid #e5e5e5; padding: 15px 20px; max-width: 600px; margin: auto;">
            Nombre: ${this.cuestionario.respuesta11}<br />
            Número: ${this.cuestionario.respuesta12}<br />
            Correo: ${this.cuestionario.respuesta13}<br /><br />
            <hr>
            ¿Quieres algo para ti? ó ¿Para alguien especial?: ${this.cuestionario.respuesta1}<br />
            ¿Tienes un diseño en mente? o ¿Te gustaría que te propusieramos ideas?: ${this.cuestionario.respuesta2}<br />
            Háznos saber si tienes una fecha planeada para asegurarnos de tenerlo a tiempo: ${this.cuestionario.respuesta3}<br />
            Fecha: ${this.cuestionario.respuesta4}<br />
            ¿Cuál es tu rango de precio?: ${this.cuestionario.respuesta5}<br />
            ¿De qué material lo deseas?: ${this.cuestionario.respuesta6}<br />
            ¿De qué color lo deseas?: ${this.cuestionario.respuesta7}<br />
            Descríbenos tu idea: ${this.cuestionario.respuesta14}<br />
            Grabado: ${this.cuestionario.respuesta9}<br />
            Información adicional: ${this.cuestionario.respuesta10}<br />
          </div>
          <div style="border: 1px solid #e5e5e5; padding: 15px 20px; max-width: 600px; margin: auto;">${this.cuestionario.imagenes}</div>
        `
      }

      await this.$api.envio.sendMail(correo)
      .then(resp => {
        this.$f7.dialog.alert('El mensaje ha sido enviado, en breve nos contactaremos contigo.', `MADAI`, () => {
            setTimeout(() => {
              location.reload()
            }, 1000)
          })
      })

      // window.emailjs.send('madai_no_reply', 'custom_template_2', correo)
      //   .then(response => {
      //     console.log('SUCCESS!', response.status, response.text)

      //     this.$f7.dialog.alert('El mensaje ha sido enviado, en breve nos contactaremos contigo.', `MADAI`, () => {
      //       setTimeout(() => {
      //         location.reload()
      //       }, 1000)
      //     })
      //   }, error => {
      //     console.log('FAILED...', error)
      //   })
    },
    buscarImagen () {
      this.$refs.fileInput.click()
    },
    imagenesSeleccionadas (event) {
      let formData = new FormData()
      this.cargandoImagen = true

      Array.from(this.$refs.fileInput.files).forEach(img => {
        formData.append('image', img)
      })

      axios.post('https://api.imgur.com/3/image', formData, {
        headers: { Authorization: 'Client-ID a565918f97f78b0', Accept: 'application/json', 'content-type': 'multipart/form-data' }
      }).then(response => {
        this.$set(this.cuestionario.imagenes, this.cuestionario.imagenes.length, response.data.data.link)
        this.cargandoImagen = false
      }).catch(error => {
        console.log(error)
        this.cargandoImagen = false
      })
    },
    eliminarImagen (link) {
      this.cuestionario.imagenes = this.cuestionario.imagenes.filter(imagen => imagen !== link)
    }
  },
  created () {
    this.$f7.utils.nextFrame(() => {
      this.$refs.respuesta1.f7SmartSelect.setValue('X')
    })
  }
}
</script>

<style scoped>
.md .icon-back, .md .icon-forward, .md .icon-next, .md .icon-prev {
  color: #1D2244 !important;
}
</style>
<style>
  .item-title {
    white-space: normal !important;
  }
</style>
